<template>
  <v-dialog v-model="dialog"
            lazy
            persistent
            max-width="600px">
    <v-card raised
            class="mt-1">
      <v-card-text class="mb-0 pb-0">
        <v-layout wrap
                  row>
          <v-flex xs10
                  offset-xs1>
            <!--<guide v-if="courierOption"
                   :text="courierOption.description" >
            </guide >-->
            <v-radio-group v-if="courierOptions.length"
                           v-model="courierOption"
                           row
                           hide-details
                           class="mb-3">
              <v-radio v-for="(courierOption, i) in courierOptions"
                       :key="courierOption.id"
                       :value="courierOption"
                       v-if="courierOption.active"
                       :label="courierOption.name">
              </v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <google-place-input class="mb-2"
                            id="destination"
                            country="KE"
                            :clearable="false"
                            :courier="true"
                            :disabled="!courierOption"
                            :enable-geolocation="true"
                            label="Enter a destination location"
                            placeholder="Destination location"
                            prepend-icon="edit_location"
                            :required="true"
                            :rules="[rules.required]"
                            :load-google-api="false"
                            :google-api-key="$app.googleMapsKey"
                            ref="destinationInput"
                            :hint="!placeResultData ? '' : placeResultData.formatted_address"
                            persistent-hint
                            types="establishment"
                            :hide-details="false"
                            v-on:placechanged="onDestinationEntered">
        </google-place-input>
        <div v-for="(destination, index) in otherDestinations">
          <v-layout row
                    wrap>
            <v-flex xs10>
              <google-place-input class="mb-2"
                                  :id="index + ''"
                                  country="KE"
                                  :clearable="false"
                                  :otherDestination="true"
                                  :courier="true"
                                  :disabled="!placeResultData"
                                  :enable-geolocation="true"
                                  label="Enter a destination location"
                                  placeholder="Destination location"
                                  prepend-icon="edit_location"
                                  :required="true"
                                  :load-google-api="false"
                                  :google-api-key="$app.googleMapsKey"
                                  :hint="!destination ? '' : destination.formatted_address"
                                  persistent-hint
                                  types="establishment"
                                  :hide-details="false"
                                  v-on:placechanged="onDestinationEntered">
              </google-place-input>
            </v-flex>
            <v-flex xs2>
              <v-btn flat
                     @click="removeOtherDestination(index)">
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <v-btn block
               flat
               color="primary"
               @click.native="addNewDestination"
               :disabled="addDestinationDisabled">
          <v-icon left
                  dark>add
          </v-icon>
          Add a destination
          <span slot="loader">Please wait...</span>
        </v-btn>

        <v-layout row
                  wrap>
          <v-flex xs5>
            <v-text-field :disabled="!placeResultData"
                          label="Enter final recipient name"
                          placeholder="Final recipient name"
                          v-model="recipientName"
                          required
                          :rules="[rules.required]"
                          prepend-icon="person">
            </v-text-field>
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs6>
            <v-text-field :disabled="!placeResultData"
                          label="Enter recipient contact"
                          placeholder="Recipient contact"
                          v-model="recipientContact"
                          required
                          :rules="[rules.required, rules.recipientContact]"
                          type="phone"
                          mask="##########"
                          :counter="10"
                          prepend-icon="phone">
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-text-field
          :disabled="!recipientContact"
          :label="quantityHint"
          :placeholder="quantityHint"
          v-model="quantity"
          :rules="[rules.required, rules.quantity]"
          required
          mask="###"
          prepend-icon="format_list_numbered">
        </v-text-field>

        <v-textarea
          name="note"
          rows="2"
          prepend-icon="note"
          v-model="note"
          label="Write a short note"
          placeholder="Instructions to the rider"
          >
        </v-textarea>
        <div class="input-group-addon" v-text=""></div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat
               color="red"
               @click.native="close">Cancel
        </v-btn>
        <v-btn small
               color="primary"
               :disabled="invalidForm"
               @click.native="onAddItem">Add item
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import GooglePlaceInput from './GooglePlaceInput'
  import Guide from './Guide'
  import {mapGetters} from 'vuex'

  export default {
    name: 'AddDeliveryItemDialog',
    components: {
      Guide,
      GooglePlaceInput
    },
    props: {
      courierOptions: {
        type: Array,
        required: false,
        default: function () {
          return []
        }
      },
      show: {
        type: Boolean,
        required: true
      },
      isAnEdit: {
        type: Boolean,
        required: false,
        default: false
      }
      // selectedItem: {
      //   type: Object,
      //   default: function () {
      //     return {
      //       recipientContact: '',
      //       recipientName: '',
      //       note: '',
      //       quantity: null,
      //       courierOption: {},
      //       destinationFormattedAddress: '',
      //       destinationVicinity: '',
      //       destinationName: '',
      //       stops: {},
      //       destinationPosition: {
      //         lat: null,
      //         lng: null
      //       }
      //     }
      //   },
      //   required: false
      // }
    },
    data: () => ({
      dialog: null,
      note: '',
      recipientContact: '',
      recipientName: '',
      quantity: 1,
      courierOption: null,
      addressData: null,
      placeResultData: null,
      addDestinationDisabled: true,
      max: 250,
      rules: {
        required: (value) => !!value || 'Required.',
        recipientContact: (value) => {
          return (!!value && ('' + value).length === 10) || 'Recipient contact must be 10 characters'
        },
        quantity: ((value) => !!value && parseInt(value) >= 1 && parseInt(value) <= 100) ||
          'Quantity cannot be less than 1 and greater than 100'
      },
      otherDestinations: []
    }),
    watch: {
      show (val) {
        this.dialog = !!val
      },
      selectedItem (newItem, oldItem) {
        if (newItem) {
        }
      }
    },
    computed: {
      quantityHint: function () {
        if (this.courierOption) {
          return 'Number of ' + this.courierOption.pluralName
        } else {
          return 'Number of items'
        }
      },
      selectedItem: function () {
        return this.getSelectedItem()
      },
      invalidForm: function () {
        return !this.courierOption || !this.addressData || !this.placeResultData ||
          ('' + this.recipientContact).length !== 10 || !this.recipientName ||
          this.quantity < 1 || this.quantity > 100
      }
    },
    methods: {
      ...mapGetters({
        getSelectedItem: 'getSelectedItem'
      }),
      addNewDestination: function () {
        this.otherDestinations.push(Vue.util.extend({}, null))
        this.addDestinationDisabled = true
      },
      removeOtherDestination: function (index) {
        this.otherDestinations.splice(index, 1)
        if (!this.otherDestinations[index]) {
          this.addDestinationDisabled = false
        }
      },
      onDestinationEntered (addressData, placeResultData, otherDestination, id) {
        if (otherDestination) {
          Vue.set(this.otherDestinations, id, placeResultData)
          this.addDestinationDisabled = false
        } else {
          this.addressData = addressData
          this.placeResultData = placeResultData
          this.addDestinationDisabled = false
        }
      },
      onAddItem: function () {
        let stops = []
        stops.push({
          stop_formatted_address: this.placeResultData.formatted_address,
          stop_vicinity: this.placeResultData.vicinity,
          stop_name: this.placeResultData.name,
          stop_latitude: this.placeResultData.geometry.location.lat(),
          stop_longitude: this.placeResultData.geometry.location.lng()
        })
        for (let i = 0; i < this.otherDestinations.length; i++) {
          if (this.otherDestinations[i]) {
            let item = {
              stop_formatted_address: this.otherDestinations[i].formatted_address,
              stop_vicinity: this.otherDestinations[i].vicinity,
              stop_name: this.otherDestinations[i].name,
              stop_latitude: this.otherDestinations[i].geometry.location.lat(),
              stop_longitude: this.otherDestinations[i].geometry.location.lng()
            }
            stops.push(item)
          }
        }
        let destination = stops[stops.length - 1]
        stops.splice(stops.length - 1, 1)
        let item = {
          recipientContact: this.recipientContact,
          recipientName: this.recipientName,
          note: this.note,
          quantity: this.quantity,
          courierOption: this.courierOption,
          destinationFormattedAddress: destination.stop_formatted_address,
          destinationVicinity: destination.stop_vicinity,
          destinationName: destination.stop_name,
          stops: stops,
          destinationPosition: {
            lat: destination.stop_latitude,
            lng: destination.stop_longitude
          }
        }
        this.$app.log('The item is: ' + JSON.stringify(item))
        this.destinationInput = ''
        this.courierOption = null
        this.note = null
        this.recipientContact = null
        this.recipientName = null
        this.quantity = 1
        this.addressData = null
        this.placeResultData = null
        this.otherDestinations = []
        this.$refs.destinationInput.clear()
        this.$emit('onAddItem', item, this.isAnEdit)
      },
      close: function () {
        this.destinationInput = ''
        this.courierOption = null
        this.note = null
        this.recipientContact = null
        this.recipientName = null
        this.quantity = 1
        this.addressData = null
        this.otherDestinations = []
        this.placeResultData = null
        this.$refs.destinationInput.clear()
        this.$emit('onClose')
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AddDeliveryItemDialog.vue